// extracted by mini-css-extract-plugin
export default {"wrapper":"StudentLessonFooter_wrapper__w3XV5"};